import React, { memo, useState, useEffect } from 'react';
import {
  Image,
  ImageBackground,
  View,
  Text,
  StyleSheet,
  Pressable,
  Dimensions,
} from 'react-native';
import { THEME, FONT, COLOR } from '../../../constants/styles';

import { useSelector, useDispatch } from 'react-redux';
import { fetchBaseSlugSuggestions } from './slice';

const BaseButton = memo((props) => {
  const handlePress = () => {
    window.location = `${window.location.origin}/base/${props.slug}`;
  };

  const [hovered, setHovered] = useState(false);
  const handleHoverIn = () => {
    setHovered(true);
  };
  const handleHoverOut = () => {
    setHovered(false);
  };

  return (
    <Pressable
      style={[styles.baseButtonContainer, hovered ? styles.baseButtonContainerHover : null]}
      onPress={handlePress}
      onHoverIn={handleHoverIn}
      onHoverOut={handleHoverOut}
    >
      <Image resizeMode="contain" style={styles.baseButtonIcon} source={{ uri: props.imageUrl }} />
      <Text style={styles.baseButtonText} numberOfLines={2}>
        {props.name}
      </Text>
    </Pressable>
  );
});

export default memo(function (props) {
  const suggestions = useSelector((state) => state.screens.baseUnauthed.baseSlugSuggestions);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchBaseSlugSuggestions({ slug: props.slug }));
  }, [dispatch, props.slug]);

  const isVertical = Dimensions.get('window').width < 450;
  return (
    <View style={{ flex: 1 }}>
      <ImageBackground
        style={{ width: '100%', height: '100%' }}
        source={require('../../../../resources/auth_bg/error404-bg.png')}
      >
        <View
          style={{
            flex: 1,
            overflow: 'auto',
            justifyContent: isVertical ? 'flex-start' : 'center',
            paddingVertical: isVertical ? 30 : 0,
            alignItems: 'center',
          }}
        >
          <View style={styles.iconContainer}>
            <Text style={[styles.label4, { transform: [{ rotate: '-12deg' }], marginRight: 14 }]}>
              4
            </Text>
            <Image
              style={styles.brandingImage}
              source={require('../../../../resources/icon.png')}
            />
            <Text style={[styles.label4, { transform: [{ rotate: '12deg' }], marginLeft: 10 }]}>
              4
            </Text>
          </View>
          <Text style={[THEME.textSemibold, { fontSize: 18, color: COLOR.emphasis }]}>
            Page Not Found
          </Text>

          {!!suggestions?.length && (
            <>
              <Text
                style={[
                  THEME.textSemibold,
                  {
                    fontSize: 18,
                    color: 'white',
                    marginTop: 10,
                    paddingHorizontal: 20,
                    textAlign: 'center',
                  },
                ]}
              >
                Looking to schedule at one of these bases?
              </Text>

              <View style={styles.buttonsContainer}>
                {suggestions.map((suggestion) => (
                  <BaseButton
                    key={suggestion.slug}
                    slug={suggestion.slug}
                    name={suggestion.name}
                    imageUrl={suggestion.logoURL}
                  />
                ))}
              </View>
            </>
          )}
        </View>
      </ImageBackground>
    </View>
  );
});

const styles = StyleSheet.create({
  iconContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16,
  },
  brandingImage: {
    width: 100,
    height: 100,
  },
  label4: {
    ...FONT.medium,
    fontSize: 90,
    color: 'white',
  },
  buttonsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 40,
  },
  baseButtonContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 10,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    borderWidth: 2,
    borderColor: '#000',
    borderRadius: 15,
    padding: 15,
    marginVertical: 10,
    minWidth: 200,
    maxWidth: 300,
  },
  baseButtonContainerHover: {
    backgroundColor: 'rgba(44, 66, 172, 0.8)',
    borderColor: '#2C42AC',
  },
  baseButtonIcon: {
    width: 75,
    height: 75,
  },
  baseButtonText: {
    ...FONT.semibold,
    fontSize: 16,
    color: 'white',
    width: 175,
    marginTop: 10,
    textAlign: 'center',
  },
});
